import FollowingTabs from "./following-tabs";

export default FollowingTabs;